import React, { useState } from 'react';
import { ThemeProvider, createMuiTheme, makeStyles } from '@material-ui/core/styles';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { Alert, Avatar, Box, Button, Grid } from '@mui/material';
import InformationEmployeeForm from './InformationEmployeeForm';
import HeaderSummary from './HeaderSummary';
import OfficeInformation from './OfficeInformation';
import Schedules from './Schedule';
import BankOfHoursAndExtraHours from './BankOfHoursAndExtraHours';
import Restrictions from './Restrictions';
import { Snackbar } from '@material-ui/core';
import { CheckCircleOutline } from '@material-ui/icons';

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',

    },
    heading: {
        fontSize: theme.typography.pxToRem(15),
        fontWeight: 'bold',
        fontFamily: 'montserrat',
        color: '#686b72'
    },
    informationHeading: {
        fontSize: 12,
        fontFamily: 'montserrat',
        color: '#686b72'
    },
    TypographyData: {
        fontFamily: 'montserrat',
        fontSize: 12,
        color: '#686b72',
        marginLeft: 10
    },
    TextField: {
        width: '100%',
        height: '10%'
    }
}));
const theme = createMuiTheme({
    overrides: {
        MuiExpansionPanel: {
            root: {
                '&:before': {
                    display: 'none',
                },
                '&$expanded': {
                    margin: 'auto',
                },
            },
        },
    },
});

//const [messageError, setMessageError] = useState('Cadastro')


export default function ExpansionPanelDataEmployee({
    viewEmployeeRegistration
}) {
    const classes = useStyles();

    return (
        <ThemeProvider theme={theme}>
            {/* //Cadastro e Colaborador */}
            <Snackbar
                open={viewEmployeeRegistration.openMessage}
                autoHideDuration={3000}
                onClose={() => viewEmployeeRegistration.setOpenMessage(false)}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }} // Adicionei esta linha
            >
                <Alert onClose={() => viewEmployeeRegistration.setOpenMessage(false)}
                    severity="success"
                    sx={{ width: '100%', backgroundColor: 'white', color: 'green' }}
                >
                    {viewEmployeeRegistration.messageSuccess}
                </Alert>
            </Snackbar>
            <Snackbar
                open={viewEmployeeRegistration.openMessageError}
                autoHideDuration={3000}
                onClose={() => viewEmployeeRegistration.setOpenMessageError(false)}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }} // Adicionei esta linha
            >
                <Alert onClose={() => viewEmployeeRegistration.setOpenMessageError(false)}
                    severity="error"
                    sx={{ width: '100%', backgroundColor: 'white', color: 'red' }}
                >
                    {viewEmployeeRegistration.messageError}
                </Alert>
            </Snackbar>
            {/* Dados Pessoais */}
            <ExpansionPanel
                expanded={viewEmployeeRegistration.openDataPerson}
                onChange={() => viewEmployeeRegistration.handleExpandClick('dataPerson')}
                style={{ borderRadius: 15, backgroundColor: viewEmployeeRegistration.completeEmployee ? '#ddf6e4' : 'white' }}
            >
                <ExpansionPanelSummary
                    expandIcon={
                        viewEmployeeRegistration.completeEmployee ?
                            <CheckCircleOutline style={{ color: 'green' }} />
                            :
                            <Avatar style={{
                                ...styles.Avatar,
                                color: viewEmployeeRegistration.isUpdate ? '#484fdb' : viewEmployeeRegistration.checkedCreatedEmployee ? '#484fdb' : '#c3c3c3',
                            }}>
                                <ExpandMoreIcon style={{ fontSize: 20 }} />
                            </Avatar>
                    }
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                    style={{ margin: 10, marginTop: 20 }}
                    onClick={() => viewEmployeeRegistration.handleSummaryDataPerson('dataPerson')}
                >
                    {
                        viewEmployeeRegistration.isUpdate ? null :
                            viewEmployeeRegistration.completeEmployee ?
                                <div style={{
                                    position: 'absolute',
                                    top: 0,
                                    left: 0,
                                    right: 0,
                                    height: '5px',
                                    backgroundColor: 'green',
                                    width: '100%',
                                    borderRadius: 15
                                }} />
                                :
                                null

                    }
                    {/* <div onClick={(event) => event.stopPropagation()} style={{ width: '100%' }}> */}
                    <div style={{ width: '100%' }}>
                        <HeaderSummary
                            classes={classes}
                            open={viewEmployeeRegistration.openDataPerson}
                            text={viewEmployeeRegistration.textDataPerson}
                            isUpdate={viewEmployeeRegistration.isUpdate}
                            atualization={viewEmployeeRegistration.atualizationButton}
                            viewEmployeeRegistration={viewEmployeeRegistration}
                            type={'employeeForm'}
                        />
                    </div>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails>
                    <InformationEmployeeForm
                        viewEmployeeRegistration={viewEmployeeRegistration}
                        handleExpandClick={viewEmployeeRegistration.handleExpandClick}
                    />
                </ExpansionPanelDetails>
            </ExpansionPanel>

            {/* //Cargo e departamento */}
            <ExpansionPanel
               expanded= {viewEmployeeRegistration.openOffice}
                onChange={() => viewEmployeeRegistration.handleExpandClick('office')}
                style={{ borderRadius: 15, backgroundColor: viewEmployeeRegistration.completeOffice ? '#ddf6e4' : 'white' }}
            >
                <ExpansionPanelSummary
                    expandIcon={
                        viewEmployeeRegistration.completeOffice ?
                            <CheckCircleOutline style={{ color: 'green' }} />
                            :
                            <Avatar style={{
                                ...styles.Avatar,
                                color: viewEmployeeRegistration.isUpdate ? '#484fdb' : viewEmployeeRegistration.checkedCreatedOffice ? '#484fdb' : '#c3c3c3',
                            }}>
                                <ExpandMoreIcon style={{ fontSize: 20 }} />
                            </Avatar>
                    }
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                    style={{ margin: 10, marginTop: 20, borderBottom: 'none' }}
                    onClick={() => viewEmployeeRegistration.handleSummaryDataPerson('office')}
                >
                    {
                        viewEmployeeRegistration.isUpdate ? null :
                            viewEmployeeRegistration.completeOffice ?
                                <div style={{
                                    position: 'absolute',
                                    top: 0,
                                    left: 0,
                                    right: 0,
                                    height: '5px',
                                    backgroundColor: 'green',
                                    width: '100%',
                                    borderRadius: 15
                                }} />
                                :
                                null

                    }
                    {/* <div onClick={(event) => event.stopPropagation()} style={{ width: '100%' }}> */}
                    <div style={{ width: '100%' }}>
                        <HeaderSummary
                            classes={classes}
                            open={viewEmployeeRegistration.openOffice}
                            text={viewEmployeeRegistration.textDataOffice}
                            isUpdate={viewEmployeeRegistration.isUpdate}
                            atualization={viewEmployeeRegistration.atualizationButton}
                            viewEmployeeRegistration={viewEmployeeRegistration}
                            type={'officeForm'}
                        />
                    </div>

                </ExpansionPanelSummary>
                <ExpansionPanelDetails>
                    <OfficeInformation
                        viewEmployeeRegistration={viewEmployeeRegistration}
                        handleExpandClick={viewEmployeeRegistration.handleExpandClick}
                    />
                </ExpansionPanelDetails>
            </ExpansionPanel>
            {/* //Escala */}
            <ExpansionPanel
                expanded={viewEmployeeRegistration.openSchedule}
                onChange={() => viewEmployeeRegistration.handleExpandClick('schedule')}
                style={{ borderRadius: 15, backgroundColor: viewEmployeeRegistration.completeSchedule ? '#ddf6e4' : 'white' }}
            >
                <ExpansionPanelSummary
                    expandIcon={
                        viewEmployeeRegistration.completeSchedule ?
                            <CheckCircleOutline style={{ color: 'green' }} />
                            :
                            <Avatar style={{
                                ...styles.Avatar,
                                color: viewEmployeeRegistration.isUpdate ? '#484fdb' : viewEmployeeRegistration.checkedCreatedSchedule ? '#484fdb' : '#c3c3c3',
                            }}>
                                <ExpandMoreIcon style={{ fontSize: 20 }} />
                            </Avatar>
                    }
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                    style={{ margin: 10, marginTop: 20 }}
                    onClick={() => viewEmployeeRegistration.handleSummaryDataPerson('schedule')}
                >
                    {
                        viewEmployeeRegistration.isUpdate ? null :
                            viewEmployeeRegistration.completeSchedule ?
                                <div style={{
                                    position: 'absolute',
                                    top: 0,
                                    left: 0,
                                    right: 0,
                                    height: '5px',
                                    backgroundColor: 'green',
                                    width: '100%',
                                    borderRadius: 15
                                }} />
                                :
                                null

                    }
                    {/* <div onClick={(event) => event.stopPropagation()} style={{ width: '100%' }}> */}
                    <div style={{ width: '100%' }}>
                        <HeaderSummary
                            classes={classes}
                            open={viewEmployeeRegistration.openSchedule}
                            text={viewEmployeeRegistration.textSchedule}
                            isUpdate={viewEmployeeRegistration.isUpdate}
                            atualization={viewEmployeeRegistration.atualizationButton}
                            viewEmployeeRegistration={viewEmployeeRegistration}
                            type={'schedule'}
                        />
                    </div>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails>
                    <Schedules viewEmployeeRegistration={viewEmployeeRegistration} />
                </ExpansionPanelDetails>
            </ExpansionPanel>
            {/* //Banco de horas e horas extras */}
            <ExpansionPanel
                expanded={viewEmployeeRegistration.openBankHours}
                onChange={() => viewEmployeeRegistration.handleExpandClick('bankOfHours')}
                style={{ borderRadius: 15, backgroundColor: viewEmployeeRegistration.completeBankOfHours ? '#ddf6e4' : 'white' }}
            >
                <ExpansionPanelSummary
                    expandIcon={
                        viewEmployeeRegistration.completeBankOfHours ?
                            <CheckCircleOutline style={{ color: 'green' }} />
                            :
                            <Avatar style={{
                                ...styles.Avatar,
                                color: viewEmployeeRegistration.isUpdate ? '#484fdb' : viewEmployeeRegistration.checkedCreatedBankOfHours ? '#484fdb' : '#c3c3c3',
                            }}>
                                <ExpandMoreIcon style={{ fontSize: 20 }} />
                            </Avatar>
                    }
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                    style={{ margin: 10, marginTop: 20 }}
                    onClick={() => viewEmployeeRegistration.handleSummaryDataPerson('bankOfHours')}
                >
                    {
                        viewEmployeeRegistration.isUpdate ? null :
                            viewEmployeeRegistration.completeBankOfHours ?
                                <div style={{
                                    position: 'absolute',
                                    top: 0,
                                    left: 0,
                                    right: 0,
                                    height: '5px',
                                    backgroundColor: 'green',
                                    width: '100%',
                                    borderRadius: 15
                                }} />
                                :
                                null

                    }
                    {/* <div onClick={(event) => event.stopPropagation()} style={{ width: '100%' }}> */}
                    <div style={{ width: '100%' }}>
                        <HeaderSummary
                            classes={classes}
                            open={viewEmployeeRegistration.openBankHours}
                            text={viewEmployeeRegistration.textBankOfHours}
                            isUpdate={viewEmployeeRegistration.isUpdate}
                            atualization={viewEmployeeRegistration.atualizationButton}
                            viewEmployeeRegistration={viewEmployeeRegistration}
                            type={'bankOfHours'}
                        />
                    </div>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails>
                    <BankOfHoursAndExtraHours viewEmployeeRegistration={viewEmployeeRegistration} />
                </ExpansionPanelDetails>
            </ExpansionPanel>
            {/* //Restrições */}
            <ExpansionPanel
                expanded={viewEmployeeRegistration.openRestrictions}
                onChange={() => viewEmployeeRegistration.handleExpandClick('restrictions')}
                style={{ borderRadius: 15, backgroundColor: viewEmployeeRegistration.completeRestrictions ? '#ddf6e4' : 'white' }}
            >
                <ExpansionPanelSummary
                    expandIcon={
                        viewEmployeeRegistration.completeRestrictions ?
                            <CheckCircleOutline style={{ color: 'green' }} />
                            :
                            <Avatar style={{
                                ...styles.Avatar,
                                color: viewEmployeeRegistration.isUpdate ? '#484fdb' : viewEmployeeRegistration.checkedCreatedRestrictions ? '#484fdb' : '#c3c3c3',
                            }}>
                                <ExpandMoreIcon style={{ fontSize: 20 }} />
                            </Avatar>
                    }
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                    style={{ margin: 10, marginTop: 20 }}
                    onClick={() => viewEmployeeRegistration.handleSummaryDataPerson('restrictions')}
                >
                    {
                        viewEmployeeRegistration.isUpdate ? null :
                            viewEmployeeRegistration.completeRestrictions ?
                                <div style={{
                                    position: 'absolute',
                                    top: 0,
                                    left: 0,
                                    right: 0,
                                    height: '5px',
                                    backgroundColor: 'green',
                                    width: '100%',
                                    borderRadius: 15
                                }} />
                                :
                                null

                    }
                    {/* <div onClick={(event) => event.stopPropagation()} style={{ width: '100%' }}> */}
                    <div style={{ width: '100%' }}>
                        <HeaderSummary
                            classes={classes}
                            open={viewEmployeeRegistration.openRestrictions}
                            text={viewEmployeeRegistration.textRestrictions}
                            isUpdate={viewEmployeeRegistration.isUpdate}
                            atualization={viewEmployeeRegistration.atualizationButton}
                            viewEmployeeRegistration={viewEmployeeRegistration}
                            type={'restrictions'}
                        />
                    </div>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails>
                    <Restrictions viewEmployeeRegistration={viewEmployeeRegistration} />
                </ExpansionPanelDetails>
            </ExpansionPanel>

        </ThemeProvider>


    );
}

const styles = {
    Avatar: {
        backgroundColor: 'white',
        border: '1px solid #c3c3c3',
        width: 30,
        height: 30
    }
}

